import { useDispatch, useSelector } from 'react-redux';
import { Share } from '../../shared/ui/Share/Share';
import cls from './Prefinal.module.scss';
import { RootState } from '../../shared/redux/store';
import { setPage } from '../../shared/redux/page/slice';
import { Pages } from '../../shared/redux/page/types';
import { sounds } from '../../shared/ui/Sound/assets';
import { useEffect, useState } from 'react';
import { Dead } from '../../shared/redux/game/types';
import DontWantBtn from '../../shared/assets/images/dont-want-button.svg';
import NoPanicBtn from '../../shared/assets/images/no-panic-button.svg';
import SorryBtn from '../../shared/assets/images/sorry-button.svg';
import { againLevel } from '../../shared/redux/game/slice';

const content = [
  {
    head: ['Айсберг по', ' правому борту!'],
    desc: [
      'Ещё чуть-чуть и ты застрянешь во льдах!',
      'Поделись игрой с друзьями, чтобы попробовать снова.',
    ],
  },
  {
    head: ['Ничего что я здесь лежу?'],
    desc: [
      'Ты потревожил местных обитателей, придётся извиняться…',
      'Поделись игрой с друзьями, чтобы сделать это и продолжить игру.',
    ],
  },
];

export const Prefinal = () => {
  const dispatch = useDispatch();
  const { hasShared, dead } = useSelector((state: RootState) => state.game);
  const isSound = useSelector((state: RootState) => state.page.isSound);
  const [currentContent, setCurrentContent] = useState(content[0]);

  useEffect(() => {
    if (dead === Dead.ICE) {
      setCurrentContent(content[0]);
    } else {
      setCurrentContent(content[1]);
    }
  }, [dead]);

  const getStyle = (type: string) => {
    if (dead === Dead.ICE) {
      if (type === 'h1') {
        return { top: '10%' };
      } else {
        if (window.innerHeight > 580) {
          return { top: '22%' };
        } else {
          return { top: '24%' };
        }
      }
    } else {
      if (type === 'h1') {
        return { top: '3%' };
      } else {
        return { top: '14%' };
      }
    }
  };
  const getBtnImage = () => {
    if (hasShared) {
      if (dead === Dead.ICE) {
        return NoPanicBtn;
      } else {
        return SorryBtn;
      }
    } else {
      return DontWantBtn;
    }
  };
  const getCls = () => {
    if (dead === Dead.ICE) {
      return cls.Pref1;
    } else {
      return cls.Pref2;
    }
  };
  console.log(hasShared);

  return (
    <div className={`${cls.Prefinal} ${getCls()}`}>
      <div className="text-container" style={getStyle('h1')}>
        <h2 className="text-bg-h2" style={{ maxWidth: '300px' }}>
          {currentContent.head.map((el) => (
            <>
              {el}
              <br />
            </>
          ))}
        </h2>
        <h2 style={{ maxWidth: '300px' }}>
          {' '}
          {currentContent.head.map((el) => (
            <>
              {el}
              <br />
            </>
          ))}
        </h2>
      </div>
      <div className="text-container" style={getStyle('p')}>
        <p className="text-bg-p">
          {currentContent.desc[0]}
          <br />
          {currentContent.desc[1]}
        </p>
        <p>
          {currentContent.desc[0]}
          <br />
          {currentContent.desc[1]}
        </p>
      </div>
      <Share style={{ bottom: '130px' }} />
      {hasShared ? (
        <button
          className={cls.dontWantBtn}
          onClick={() => {
            if (isSound) {
              sounds.btn.play();
            }
            dispatch(setPage(Pages.GAME));
            dispatch(againLevel());
          }}>
          <img alt="btn" src={getBtnImage()} />
        </button>
      ) : (
        <button
          className={cls.dontWantBtn}
          onClick={() => {
            if (isSound) {
              sounds.btn.play();
            }

            dispatch(setPage(Pages.FINAL));
          }}>
          <img alt="btn" src={getBtnImage()} />
        </button>
      )}
    </div>
  );
};
